import dynamic from "next/dynamic";

import {
  addressInfoSchema,
  contactInfoSchema,
  documentlInfoSchema,
  passwordSchema,
} from "@/validations/registration/registration.validation";
import { TRegistrationUz } from "@/types/registrationUz.types";
import { RegistrationStepUz } from "@/enums/registrationSteps.enum";

const ContactInfo = dynamic(
  () => import("@/components/auth/registration/form-components/contact-info"),
);
const Password = dynamic(
  () => import("@/components/auth/registration/form-components/password"),
);
const DocumentInfoUzbekistan = dynamic(
  () =>
    import(
      "@/components/auth/registration/form-components/document-info-uzbekistan"
    ),
);
const AddressInfoUzbekistan = dynamic(
  () =>
    import(
      "@/components/auth/registration/form-components/address-info-uzbekistan"
    ),
);

export const registrationStepsDataUz: TRegistrationUz = {
  [RegistrationStepUz.CONTACTINFO]: {
    stepName: "registration_contact_information",
    component: <ContactInfo />,
    validationSchema: contactInfoSchema,
    needsToken: false,
  },
  [RegistrationStepUz.PASSWORD]: {
    stepName: "password",
    component: <Password />,
    validationSchema: passwordSchema,
    needsToken: false,
  },
  [RegistrationStepUz.DOCUMENTINFO]: {
    stepName: "registration_document_information",
    component: <DocumentInfoUzbekistan />,
    validationSchema: documentlInfoSchema,
    needsToken: true,
  },
  [RegistrationStepUz.ADDRESSINFO]: {
    stepName: "registration_address_information",
    component: <AddressInfoUzbekistan />,
    validationSchema: addressInfoSchema,
    needsToken: true,
  },
};
